import { render } from "./GridTipuriConcedii.vue?vue&type=template&id=11b7d4b4&ts=true"
import script from "./GridTipuriConcedii.vue?vue&type=script&lang=ts"
export * from "./GridTipuriConcedii.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__